import { ShieldCheck, Lock, CheckCircle, Zap } from "lucide-react";
import TechSectionHeader from "./TechSectionHeader";
import "./tech-security.css";

export default function TechSecurity() {
  return (
    <section className="oglitz-tech-security">
      <div className="oglitz-tech-security__container">
        <TechSectionHeader
          eyebrow="OUR SERVICES"
          title="Security &"
          highlight="Performance"
          subtitle="Built-in protection, compliance-ready systems, and performance optimized for scale."
          dark
        />

        <div className="oglitz-tech-security__grid">
          <div className="oglitz-tech-security__card">
            <ShieldCheck />
            <h3>Secure Authentication</h3>
            <p>
              Role-based access control, OAuth, JWT, and enterprise-grade
              authentication flows.
            </p>
          </div>

          <div className="oglitz-tech-security__card">
            <Lock />
            <h3>Encrypted Data Handling</h3>
            <p>
              End-to-end encryption for data at rest and in transit using
              industry standards.
            </p>
          </div>

          <div className="oglitz-tech-security__card">
            <CheckCircle />
            <h3>Code Quality & Audits</h3>
            <p>
              Clean architecture, regular audits, and automated testing to
              ensure reliability.
            </p>
          </div>

          <div className="oglitz-tech-security__card">
            <Zap />
            <h3>Performance Optimization</h3>
            <p>
              Fast load times, optimized APIs, caching strategies, and scalable
              delivery pipelines.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
